/*
Monotype Foundry Platform API
Version 1.0.0

Definition: SplitFamilyRequest

Properties:
  familyName: string (required)
  binaryIds: array (required)
*/

var SplitFamilyRequest = (function () {
  function validateSplitFamilyRequest (arg) {
    // Validate familyName
    if (!arg.familyName) {
      throw new Error('SplitFamilyRequest.familyName: Missing property')
    }
    if (arg.familyName && !(typeof arg.familyName === 'string')) {
      throw new Error('SplitFamilyRequest.familyName: Wrong type: Got \'' + (typeof arg.familyName) + '\', but expected: \'string\'')
    }
    // Validate binaryIds
    if (!arg.binaryIds) {
      throw new Error('SplitFamilyRequest.binaryIds: Missing property')
    }
    if (arg.binaryIds && !(Array.isArray(arg.binaryIds))) {
      throw new Error('SplitFamilyRequest.binaryIds: Wrong type: Got \'' + (typeof arg.binaryIds) + '\', but expected: \'array\'')
    }
  }
  function buildSplitFamilyRequest (arg) {
    var SplitFamilyRequest = arg
    // Complete familyName
    // Expected Type: string
    SplitFamilyRequest.familyName = SplitFamilyRequest.familyName || ''
    // Complete binaryIds
    // Expected Type: array
    SplitFamilyRequest.binaryIds = SplitFamilyRequest.binaryIds || []
    return SplitFamilyRequest
  }
  return {
    validate: validateSplitFamilyRequest,
    build: buildSplitFamilyRequest
  }
})()

module.exports = SplitFamilyRequest
